/**
 * 配列をクエリ用文字列に変換する関数
 * @param {string} key - クエリ用のキー名
 * @param {array} values - クエリ用の配列
 * @return {string} クエリ用文字列
 */
export function createQueryFromArray(
  key: string,
  values: Array<string | number>
) {
  return values.map(value => `${key}[]=${String(value)}`).join("&");
}

export function verifyHttp(url: string): boolean {
  const acceptedScheme = ["https", "http"];
  const scheme = url.split(":")[0];
  return acceptedScheme.includes(scheme);
}

export const getCurrentRootURL = () => {
  const { protocol, host } = window.location;
  return `${protocol}//${host}`;
};
